import React from 'react';
export function PrivacyPolicyContent() {
  return <div className="prose prose-sm md:prose-base max-w-none" data-id="element-38">
      <section className="mb-8" data-id="element-39">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-40">
          1. Información que Recopilamos
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-41">
          Recopilamos información que usted nos proporciona directamente cuando
          se registra en nuestro servicio, realiza una compra, o se comunica con
          nosotros. Esto puede incluir su nombre, dirección de correo
          electrónico, información de pago y cualquier otra información que
          decida proporcionarnos.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-42">
          También recopilamos automáticamente cierta información sobre su
          dispositivo cuando accede a nuestro sitio, incluyendo información
          sobre su navegador web, dirección IP, zona horaria y cookies
          instaladas en su dispositivo.
        </p>
      </section>

      <section className="mb-8" data-id="element-43">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-44">
          2. Uso de la Información
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-45">
          Utilizamos la información que recopilamos para:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4" data-id="element-46">
          <li data-id="element-47">
            Procesar sus transacciones y entregarle los productos o servicios
            solicitados
          </li>
          <li data-id="element-48">
            Comunicarnos con usted sobre su cuenta, pedidos o actualizaciones
            del servicio
          </li>
          <li data-id="element-49">Mejorar y personalizar su experiencia en nuestro sitio</li>
          <li data-id="element-50">Enviarle información de marketing (con su consentimiento)</li>
          <li data-id="element-51">Prevenir fraudes y proteger la seguridad de nuestros usuarios</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-52">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-53">
          3. Protección de Datos
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-54">
          Implementamos medidas de seguridad técnicas y organizativas apropiadas
          para proteger su información personal contra el acceso no autorizado,
          la alteración, divulgación o destrucción. Sin embargo, ningún método
          de transmisión por Internet o almacenamiento electrónico es 100%
          seguro.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-55">
          Sus datos de pago son procesados de forma segura a través de
          proveedores de servicios de pago certificados que cumplen con los
          estándares de la industria.
        </p>
      </section>

      <section className="mb-8" data-id="element-56">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-57">
          4. Cookies y Tecnologías Similares
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-58">
          Utilizamos cookies y tecnologías similares para mejorar su experiencia
          en nuestro sitio, analizar el tráfico y personalizar el contenido.
          Puede configurar su navegador para rechazar todas las cookies o para
          indicar cuándo se envía una cookie.
        </p>
      </section>

      <section className="mb-8" data-id="element-59">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-60">
          5. Sus Derechos
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-61">
          Usted tiene derecho a:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4" data-id="element-62">
          <li data-id="element-63">Acceder a la información personal que tenemos sobre usted</li>
          <li data-id="element-64">Solicitar la corrección de información inexacta</li>
          <li data-id="element-65">Solicitar la eliminación de su información personal</li>
          <li data-id="element-66">Oponerse al procesamiento de su información personal</li>
          <li data-id="element-67">Solicitar la portabilidad de sus datos</li>
          <li data-id="element-68">Retirar su consentimiento en cualquier momento</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-69">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-70">
          6. Cambios a esta Política
        </h3>
        <p className="text-gray-700 leading-relaxed" data-id="element-71">
          Podemos actualizar esta Política de Privacidad periódicamente. Le
          notificaremos sobre cualquier cambio publicando la nueva política en
          esta página y actualizando la fecha de "última actualización". Le
          recomendamos revisar esta política periódicamente.
        </p>
      </section>

      <section data-id="element-72">
        <p className="text-gray-600 text-sm italic" data-id="element-73">
          Última actualización: Febrero 2024
        </p>
      </section>
    </div>;
}
export function TermsOfServiceContent() {
  return <div className="prose prose-sm md:prose-base max-w-none" data-id="element-74">
      <section className="mb-8" data-id="element-75">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-76">
          1. Aceptación de los Términos
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-77">
          Al acceder y utilizar este servicio, usted acepta estar sujeto a estos
          Términos de Servicio y todas las leyes y regulaciones aplicables. Si
          no está de acuerdo con alguno de estos términos, no debe utilizar este
          servicio.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-78">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Su uso continuado del servicio después de cualquier cambio
          constituye su aceptación de los nuevos términos.
        </p>
      </section>

      <section className="mb-8" data-id="element-79">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-80">
          2. Uso del Servicio
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-81">
          Usted se compromete a utilizar este servicio únicamente para fines
          legales y de acuerdo con estos términos. Específicamente, usted acepta
          no:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4" data-id="element-82">
          <li data-id="element-83">
            Utilizar el servicio de manera que viole cualquier ley o regulación
            aplicable
          </li>
          <li data-id="element-84">
            Transmitir material que sea difamatorio, obsceno, ofensivo o ilegal
          </li>
          <li data-id="element-85">
            Intentar obtener acceso no autorizado a cualquier parte del servicio
          </li>
          <li data-id="element-86">Interferir con el funcionamiento adecuado del servicio</li>
          <li data-id="element-87">
            Utilizar el servicio para enviar spam o contenido no solicitado
          </li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-88">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-89">
          3. Propiedad Intelectual
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-90">
          Todo el contenido incluido en este servicio, como texto, gráficos,
          logos, imágenes, videos y software, es propiedad nuestra o de nuestros
          proveedores de contenido y está protegido por las leyes de derechos de
          autor y propiedad intelectual.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-91">
          No puede reproducir, distribuir, modificar o crear trabajos derivados
          de nuestro contenido sin nuestro permiso expreso por escrito.
        </p>
      </section>

      <section className="mb-8" data-id="element-92">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-93">
          4. Compras y Pagos
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-94">
          Al realizar una compra a través de nuestro servicio, usted acepta
          proporcionar información de pago actual, completa y precisa. Nos
          reservamos el derecho de rechazar o cancelar cualquier pedido por
          cualquier motivo, incluyendo limitaciones de disponibilidad, errores
          en la información del producto o precio, o problemas identificados por
          nuestro departamento de fraude.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-95">
          Todos los precios están sujetos a cambios sin previo aviso. Los pagos
          se procesan de forma segura a través de proveedores de servicios de
          pago de terceros.
        </p>
      </section>

      <section className="mb-8" data-id="element-96">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-97">
          5. Limitación de Responsabilidad
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-98">
          En la máxima medida permitida por la ley, no seremos responsables de
          ningún daño indirecto, incidental, especial, consecuente o punitivo, o
          cualquier pérdida de beneficios o ingresos, ya sea incurrida directa o
          indirectamente, o cualquier pérdida de datos, uso, buena voluntad u
          otras pérdidas intangibles.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-99">
          El servicio se proporciona "tal cual" sin garantías de ningún tipo, ya
          sean expresas o implícitas.
        </p>
      </section>

      <section className="mb-8" data-id="element-100">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-101">
          6. Terminación
        </h3>
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-102">
          Podemos terminar o suspender su acceso a nuestro servicio
          inmediatamente, sin previo aviso o responsabilidad, por cualquier
          motivo, incluyendo sin limitación si usted incumple estos Términos de
          Servicio.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-103">
          Todas las disposiciones de estos términos que por su naturaleza deban
          sobrevivir a la terminación sobrevivirán, incluyendo sin limitación
          las disposiciones de propiedad, exenciones de garantía, indemnización
          y limitaciones de responsabilidad.
        </p>
      </section>

      <section className="mb-8" data-id="element-104">
        <h3 className="text-xl font-bold text-emerald-primary mb-4" data-id="element-105">
          7. Ley Aplicable
        </h3>
        <p className="text-gray-700 leading-relaxed" data-id="element-106">
          Estos términos se regirán e interpretarán de acuerdo con las leyes de
          Colombia, sin tener en cuenta sus disposiciones sobre conflictos de
          leyes. Cualquier disputa relacionada con estos términos estará sujeta
          a la jurisdicción exclusiva de los tribunales de Colombia.
        </p>
      </section>

      <section data-id="element-107">
        <p className="text-gray-600 text-sm italic" data-id="element-108">
          Última actualización: Febrero 2024
        </p>
      </section>
    </div>;
}